import { render, staticRenderFns } from "./NavUserCenterVip.vue?vue&type=template&id=71e84f8a&scoped=true&"
import script from "./NavUserCenterVip.vue?vue&type=script&lang=js&"
export * from "./NavUserCenterVip.vue?vue&type=script&lang=js&"
import style0 from "./NavUserCenterVip.vue?vue&type=style&index=0&id=71e84f8a&lang=less&scoped=true&"
import style1 from "./NavUserCenterVip.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e84f8a",
  null
  
)

export default component.exports